import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { DepartureMonitorService, IStation, IStationDeparture } from './departure-monitor.service';
import { ModalController } from '@ionic/angular';
import { switchMap } from 'rxjs/operators';
import { StationsPage } from './stations/stations.page';
import { OverlayEventDetail } from '@ionic/core';
import { AppState } from 'src/app/app.module';
import { settingsFeature } from 'src/app/ngrx/settings/settings.feature';

@Injectable({
  providedIn: 'root'
})
export class DefaultStationGuard  {
  private store = inject<Store<AppState>>(Store);
  private router = inject(Router);
  private departureService = inject(DepartureMonitorService);
  private modalController = inject(ModalController);

  private station: Observable<{ remember: boolean; rememberedId: string | null }>;

  constructor() {
    this.station = this.store.pipe(select(settingsFeature.selectDepartureStation));
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.station.pipe(
      switchMap((station: { remember: boolean; rememberedId: string | null }) => {
        if (station.remember && station.rememberedId) {
          return of(
            this.router.createUrlTree(['/departure-monitor', station.rememberedId], {
              queryParams: {
                name: station.rememberedId
              }
            })
          );
        } else {
          return from(
            this.modalController.create({
              component: StationsPage
            })
          ).pipe(
            switchMap((modal: HTMLIonModalElement) => {
              modal.present();
              return from(modal.onDidDismiss()).pipe(
                switchMap((selectedData: OverlayEventDetail<IStation>) => {
                  const selectedStation = selectedData.data;
                  if(selectedStation) {
                    return of(
                      this.router.createUrlTree(['/departure-monitor', selectedStation.id], {
                        queryParams: {
                          name: selectedStation.name
                        }
                      })
                    );
                  } else {
                    return of(false);
                  }
                })
              );
            })
          );
        }
      })
    );
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<IStationDeparture[]> {
    const stationId = route.paramMap.get('stationId');
    if (stationId) {
      return this.departureService.departures(stationId);
    }
    return of([]);
  }
}
